/*
 * @Author: 郑君婵
 * @Date: 2020-09-28 10:52:54
 * @LastEditTime: 2020-12-29 15:30:13
 * @Description: session过期处理
 */
import { logout } from '@/services/user'
import { useWujieMethod } from "@/utils/subWujie/method";

export default () => {
  // 无界通知主应用
  // eslint-disable-next-line no-underscore-dangle
  if (window.__POWERED_BY_WUJIE__) {
    const { INJECT_SUBAPP_SESSION_EXPIRE } = useWujieMethod();
    INJECT_SUBAPP_SESSION_EXPIRE()
    logout()
  }else {
    logout()
    window.location.href='/#/login';
  }

}
